// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(//fonts.googleapis.com/earlyaccess/notosanstc.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  -webkit-text-size-adjust: 100%;
}
/*--------------------------------------------------------------
// # Header
/--------------------------------------------------------------*/
.navbar {
  width: 100%;
  height: 60px;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.navbar .logo {
  min-width: 200px;
}

.navbar .logo a {
  font-size: 1.5rem;
  font-weight: bold;

}

.navbar .links {
  display: flex;
  gap: 2rem;
  min-width: 600px;
}

.navbar .toggle_btn {
  color: #fff;
  font-size: 1.5 rem;
  cursor: pointer;
  display: none;
}

.action_btn {
  background-color: orange;
  color: #fff;
  padding: 0.5rem 1rem;
  border: none;
  outline: none;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: bold;
  cursor: pointer;
  transition: scale 0.2 ease;
  min-width: -moz-fit-content;
  min-width: fit-content;
}

.action_btn:hover {
  scale: 1.05;
  transition-duration: 0.25s;
  color: #fff;
}

.action_btn:active {
  scale: 0.95;
  transition-duration: 0.25s;
}


/*--------------------------------------------------------------
// # Dropdown Menu
/--------------------------------------------------------------*/
.dropdown_menu {
  position: absolute;
  right: 2rem;
  top: 60px;
  width: 300px;
  height: 0;
  background: rgba(0, 0, 0, 0.5);
  -webkit-backdrop-filter: blur(15px);
          backdrop-filter: blur(15px);
  border-radius: 10px;
  overflow: hidden;
  transition: height .2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  display: none;
  z-index: 2;
 
}
.dropdown_menu.open{
  height: 240px;
}

.dropdown_menu li {
  padding: 0.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
}


.dropdown_menu .action_btn {
  width: 100%;
  display: flex;
  justify-content: center;
}

/*--------------------------------------------------------------
///////////////////////////General//////////////////////////////
/--------------------------------------------------------------*/
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Noto Sans TC',sans-serif !important;
}

body{
  min-height: 100vh;
  background-color: #fff;
}

header{
  position: absolute;
  width: 100%;
  min-height: 66px;
  /* background-color: #43a5f6; */
  background-color: #fff;
  padding: 0 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;


}

header .logo{
  color: black;
  font-size: 1.75rem;
  font-weight: 600;
  text-decoration: none;
}

.logo img{
  width: 70px;
  height: 70px;
}


header ul{
  position: relative;
}
.Links{
  display: flex;

}
header ul li{
  position: relative;
  list-style: none;
  float: left;
}


header ul li a{
  color: black;
  min-width: 150px;
  font-size: 1.0em;
  padding: 20px 25px;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
}
header ul div{
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

header ul li div .sign-up-button{
  font-size: 12px;
  
  font-weight: bolder;
  max-height: 30px;
  width: 100px;
  line-height: 100%;
  background-color: #FFB800;
  color: #fff;
  text-shadow: 1px 1px 5px #000;
  box-shadow: 2px 2px 8px #6e6c6c; 
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 25px;
}

header ul li a:hover{
  background-color: #ebebebc2;
  color: #FFB800;;
}



header ul li ul{
  position: absolute;
  left: 0;
  width: 100%;
  background-color: #c9c9c9;
  box-shadow: 2px 2px 8px #6e6c6c;
  padding: 0;
  display: none;
}
header ul li:hover ul{
  display: block;
  border-radius: 0 0 10px 10px;
}

header ul li ul li{
  width: 100%;
  position: relative;
  
}

header ul li ul li a{
  padding: 15px 20px;
  color: rgb(0, 0, 0)505;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9em;
}


.title-container{
  min-width: calc(100% - 4rem);
  display: flex;
  min-height: 50px;
  font-size: 1.2rem;
  font-weight: bolder;
  justify-content: center;
  align-items: center;
  background-color: #F6F6F6;
  box-shadow: 2px 2px 10px #00000042;
  margin: 5px 2rem;
  
}
.title-container div{
  padding: 0 20px;
}


.bullet-point{
  min-width: calc(100% - 4rem);
  min-height: 40px;
  margin: 10px 2rem;
  font-size: 1.2rem;
  font-weight: bolder;
  line-height: 40px;
  text-shadow: 3px 3px 3px rgba(226, 223, 223, 0.747);
  list-style-type: circle;
  background-color: #FFB800;
  
  box-shadow: 4px 4px 10px #00000042;
}

.sub-bullet-point{
  min-width: 100%;
  min-height: 40px;
  font-size: 1.2rem;
  font-weight: bolder;
  line-height: 40px;
  text-shadow: 3px 3px 3px rgba(226, 223, 223, 0.747);
  list-style-type: circle;
  background-color: #FFB800;
  box-shadow: 4px 4px 10px #00000042;
  margin-bottom: 10px;
}

.simulation-description{
  min-width: calc(100% - 4rem);
  min-height: 40px;
  font-size: 1.2rem;
  margin: 10px 2rem;
  font-weight: bolder;
  line-height: 40px;
  padding: 10px 0;
  text-shadow: 3px 3px 3px rgba(226, 223, 223, 0.747);
  list-style-type: circle;
  border-bottom: 1px dotted #aaa3a342;

}
/* Question Section */
.question-section{
  min-width: calc(100% - 4rem);
  min-height: 100px;
  font-size: 1.2rem;
  margin: 10px 2rem;
  font-weight: bolder;
  line-height: 40px;
  padding: 10px 0;
  text-shadow: 3px 3px 3px rgba(226, 223, 223, 0.747);
  list-style-type: circle;
  border-bottom: 1px dotted #aaa3a342;
}
.input-ans-area {
  width: 100%;
  height: 70px;
  white-space: pre-wrap;
}
/* * {  OLD RESET
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Open Sans', sans-serif;
}

body {
  height: 130vh ;
  background-color: #000; 
  background-size: cover;
  background-position: center;
  
}

li {
  list-style: none;
}

a {
  text-decoration: none;
  color: #fff; 
  font-size: 1rem;
}

a:hover {
  color: orange;
} */


/* HEADER */
header {
  position: relative;
  padding: 0 2rem;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}


`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAGA;EACE,8BAA8B;AAChC;AACA;;gEAEgE;AAChE;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;;AAEnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,2BAAsB;EAAtB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;;AAGA;;gEAEgE;AAChE;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,SAAS;EACT,8BAA8B;EAC9B,mCAA2B;UAA3B,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,8DAA8D;EAC9D,aAAa;EACb,UAAU;;AAEZ;AACA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;;gEAEgE;AAChE;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;;AAGrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;;AAEf;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;;AAGA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;;EAEf,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,6BAA6B;EAC7B,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;;;AAIA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,+BAA+B;EAC/B,UAAU;EACV,aAAa;AACf;AACA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;;AAEpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;;AAGA;EACE,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kCAAkC;EAClC,gBAAgB;;AAElB;AACA;EACE,eAAe;AACjB;;;AAGA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,mDAAmD;EACnD,uBAAuB;EACvB,yBAAyB;;EAEzB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,mDAAmD;EACnD,uBAAuB;EACvB,yBAAyB;EACzB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,mDAAmD;EACnD,uBAAuB;EACvB,mCAAmC;;AAErC;AACA,qBAAqB;AACrB;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,mDAAmD;EACnD,uBAAuB;EACvB,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;GA2BG;;;AAGH,WAAW;AACX;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;aACW;AACb","sourcesContent":["@import url(//fonts.googleapis.com/earlyaccess/notosanstc.css);\n\n\nhtml {\n  -webkit-text-size-adjust: 100%;\n}\n/*--------------------------------------------------------------\n// # Header\n/--------------------------------------------------------------*/\n.navbar {\n  width: 100%;\n  height: 60px;\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.navbar .logo {\n  min-width: 200px;\n}\n\n.navbar .logo a {\n  font-size: 1.5rem;\n  font-weight: bold;\n\n}\n\n.navbar .links {\n  display: flex;\n  gap: 2rem;\n  min-width: 600px;\n}\n\n.navbar .toggle_btn {\n  color: #fff;\n  font-size: 1.5 rem;\n  cursor: pointer;\n  display: none;\n}\n\n.action_btn {\n  background-color: orange;\n  color: #fff;\n  padding: 0.5rem 1rem;\n  border: none;\n  outline: none;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: bold;\n  cursor: pointer;\n  transition: scale 0.2 ease;\n  min-width: fit-content;\n}\n\n.action_btn:hover {\n  scale: 1.05;\n  transition-duration: 0.25s;\n  color: #fff;\n}\n\n.action_btn:active {\n  scale: 0.95;\n  transition-duration: 0.25s;\n}\n\n\n/*--------------------------------------------------------------\n// # Dropdown Menu\n/--------------------------------------------------------------*/\n.dropdown_menu {\n  position: absolute;\n  right: 2rem;\n  top: 60px;\n  width: 300px;\n  height: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(15px);\n  border-radius: 10px;\n  overflow: hidden;\n  transition: height .2s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  display: none;\n  z-index: 2;\n \n}\n.dropdown_menu.open{\n  height: 240px;\n}\n\n.dropdown_menu li {\n  padding: 0.7rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n.dropdown_menu .action_btn {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n/*--------------------------------------------------------------\n///////////////////////////General//////////////////////////////\n/--------------------------------------------------------------*/\n*{\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: 'Noto Sans TC',sans-serif !important;\n}\n\nbody{\n  min-height: 100vh;\n  background-color: #fff;\n}\n\nheader{\n  position: absolute;\n  width: 100%;\n  min-height: 66px;\n  /* background-color: #43a5f6; */\n  background-color: #fff;\n  padding: 0 100px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n\n}\n\nheader .logo{\n  color: black;\n  font-size: 1.75rem;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.logo img{\n  width: 70px;\n  height: 70px;\n}\n\n\nheader ul{\n  position: relative;\n}\n.Links{\n  display: flex;\n\n}\nheader ul li{\n  position: relative;\n  list-style: none;\n  float: left;\n}\n\n\nheader ul li a{\n  color: black;\n  min-width: 150px;\n  font-size: 1.0em;\n  padding: 20px 25px;\n  text-decoration: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\nheader ul div{\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\nheader ul li div .sign-up-button{\n  font-size: 12px;\n  \n  font-weight: bolder;\n  max-height: 30px;\n  width: 100px;\n  line-height: 100%;\n  background-color: #FFB800;\n  color: #fff;\n  text-shadow: 1px 1px 5px #000;\n  box-shadow: 2px 2px 8px #6e6c6c; \n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 25px;\n}\n\nheader ul li a:hover{\n  background-color: #ebebebc2;\n  color: #FFB800;;\n}\n\n\n\nheader ul li ul{\n  position: absolute;\n  left: 0;\n  width: 100%;\n  background-color: #c9c9c9;\n  box-shadow: 2px 2px 8px #6e6c6c;\n  padding: 0;\n  display: none;\n}\nheader ul li:hover ul{\n  display: block;\n  border-radius: 0 0 10px 10px;\n}\n\nheader ul li ul li{\n  width: 100%;\n  position: relative;\n  \n}\n\nheader ul li ul li a{\n  padding: 15px 20px;\n  color: rgb(0, 0, 0)505;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.9em;\n}\n\n\n.title-container{\n  min-width: calc(100% - 4rem);\n  display: flex;\n  min-height: 50px;\n  font-size: 1.2rem;\n  font-weight: bolder;\n  justify-content: center;\n  align-items: center;\n  background-color: #F6F6F6;\n  box-shadow: 2px 2px 10px #00000042;\n  margin: 5px 2rem;\n  \n}\n.title-container div{\n  padding: 0 20px;\n}\n\n\n.bullet-point{\n  min-width: calc(100% - 4rem);\n  min-height: 40px;\n  margin: 10px 2rem;\n  font-size: 1.2rem;\n  font-weight: bolder;\n  line-height: 40px;\n  text-shadow: 3px 3px 3px rgba(226, 223, 223, 0.747);\n  list-style-type: circle;\n  background-color: #FFB800;\n  \n  box-shadow: 4px 4px 10px #00000042;\n}\n\n.sub-bullet-point{\n  min-width: 100%;\n  min-height: 40px;\n  font-size: 1.2rem;\n  font-weight: bolder;\n  line-height: 40px;\n  text-shadow: 3px 3px 3px rgba(226, 223, 223, 0.747);\n  list-style-type: circle;\n  background-color: #FFB800;\n  box-shadow: 4px 4px 10px #00000042;\n  margin-bottom: 10px;\n}\n\n.simulation-description{\n  min-width: calc(100% - 4rem);\n  min-height: 40px;\n  font-size: 1.2rem;\n  margin: 10px 2rem;\n  font-weight: bolder;\n  line-height: 40px;\n  padding: 10px 0;\n  text-shadow: 3px 3px 3px rgba(226, 223, 223, 0.747);\n  list-style-type: circle;\n  border-bottom: 1px dotted #aaa3a342;\n\n}\n/* Question Section */\n.question-section{\n  min-width: calc(100% - 4rem);\n  min-height: 100px;\n  font-size: 1.2rem;\n  margin: 10px 2rem;\n  font-weight: bolder;\n  line-height: 40px;\n  padding: 10px 0;\n  text-shadow: 3px 3px 3px rgba(226, 223, 223, 0.747);\n  list-style-type: circle;\n  border-bottom: 1px dotted #aaa3a342;\n}\n.input-ans-area {\n  width: 100%;\n  height: 70px;\n  white-space: pre-wrap;\n}\n/* * {  OLD RESET\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: 'Open Sans', sans-serif;\n}\n\nbody {\n  height: 130vh ;\n  background-color: #000; \n  background-size: cover;\n  background-position: center;\n  \n}\n\nli {\n  list-style: none;\n}\n\na {\n  text-decoration: none;\n  color: #fff; \n  font-size: 1rem;\n}\n\na:hover {\n  color: orange;\n} */\n\n\n/* HEADER */\nheader {\n  position: relative;\n  padding: 0 2rem;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
